import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import pick from 'lodash/pick';
import reject from 'lodash/reject';
import get from 'lodash/get';
import SelectableBox from '../../../common/selectableBox';
import * as selector from '../../barbers/selector';

class SelectServices extends Component {
  static mapService(service) {
    return pick(service, ['id', 'cost', 'costWithTaxes', 'costWithoutTaxes', 'taxAmount', 'tax', 'duration', 'name']);
  }

  addSelectedService(service) {
    const result = [...this.props.selectedServices];
    result.push(SelectServices.mapService(service));

    return result;
  }

  removeSelectedService(service) {
    return reject(this.props.selectedServices, item => item.id === service.id);
  }

  updateSelectedServices(service) {
    if (!this.props.allowMultipleServices) {
      return [SelectServices.mapService(service)];
    }

    if (this.isServiceSelected(service)) {
      return this.removeSelectedService(service);
    }

    return this.addSelectedService(service);
  }

  filterServices(services) {
    const serviceInArray = service => item => item.id === service.id;
    return services.filter(service => this.props.services.find(serviceInArray(service)));
  }

  selectService = (service) => {
    const services = this.filterServices(this.updateSelectedServices(service));
    this.props.selectServices(services);
  };

  isServiceSelected(service) {
    return this.props.selectedServices.some(item => item.id === service.id);
  }

  render() {
    const { selectedBarber, services, timesFetching } = this.props;
    const barberHasNoServices = selectedBarber && !services.length;

    return (
      <div className="layout__item u-mb--" data-automation-id="services">
        <div className="c-label c-label--small-green">Services</div>
        <div
          className="u-fontsize-extrasmall u-font-color-grey"
          display-if={!selectedBarber}
        >
          Please select a barber to see services
        </div>
        <div display-if={barberHasNoServices}>Barber has no services</div>
        { services.map(service => (
          <SelectableBox
            selected={this.isServiceSelected(service)}
            service={service}
            key={service.id}
            selectService={this.selectService}
            unclickable={timesFetching || !this.props.canModifyAppointments}
            automationId={`selectable:service:${service.id}`}
          />
        )) }
      </div>
    );
  }
}

SelectServices.propTypes = {
  services: PropTypes.array,
  selectedBarber: PropTypes.string,
  allowMultipleServices: PropTypes.bool,
  selectServices: PropTypes.func,
  selectedServices: PropTypes.array,
  timesFetching: PropTypes.bool,
  canModifyAppointments: PropTypes.bool.isRequired,
};

SelectServices.defaultProps = {
  services: [],
  selectedBarber: '',
  allowMultipleServices: false,
  selectServices: () => null,
  selectedServices: [],
  timesFetching: false,
};

const mapStateToProps = (state, props) => {
  const appointmentServices = get(props, 'appointment.appointment_service', []);
  const barberServices = selector.getBarberServices(state, props.selectedBarber);

  return {
    services: barberServices.map((service) => {
      const serviceFromAppointment = appointmentServices.find(({ service: { id } }) => service.id === id);

      if (serviceFromAppointment) {
        return {
          ...service,
          cost: serviceFromAppointment.costWithoutTaxes,
        };
      }

      return service;
    }),
    timesFetching: state.barbers.availableTimes.loading,
  };
};

export default connect(mapStateToProps, null)(SelectServices);
